import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import StorageHero from './components/StorageHero';
import AudienceToggle from './components/AudienceToggle';
import CapacityMapping from './components/CapacityMapping';
import EarningSection from './components/EarningSection';
import FeaturesSection from './components/FeaturesSection';
import OnboardingSteps from './components/OnboardingSteps';
import SeekerContent from './components/SeekerContent';
import StorageCTABand from './components/StorageCTABand';

export default function StoragePage() {
  const [audience, setAudience] = useState<'owner' | 'seeker'>('owner');

  return (
    <>
      <Navbar />
      <main>
        <StorageHero />
        <AudienceToggle active={audience} onChange={setAudience} />

        {audience === 'owner' ? (
          <>
            <CapacityMapping />
            <EarningSection />
            <FeaturesSection />
            <OnboardingSteps />
          </>
        ) : (
          <SeekerContent />
        )}

        <StorageCTABand />
      </main>
      <Footer />
    </>
  );
}